import { useEffect, useState } from 'react'
import { Outlet, useNavigate, useParams, useLocation } from 'react-router-dom'
import logo from '../../assets/images/logo.svg'
import menuIcon from '../../assets/images/menu-icon.svg'
import excelIcon from '../../assets/images/upload icon.png'
import logoutIcon from '../../assets/images/buttons/LOG-OUT-icon.svg'
import sidebarItems from './const'
import AccountDetailsFooter from '../../components/userAdmin/AccountDetailsFooter'
import { useAuth } from '../../hooks/useAuth'
import { useAuthContext } from '../../contexts/AuthContext'
import { logger } from '../../utils'
import { Text } from '../../components/atoms'
import ProgressiveImage from '../../components/molecules/ProgressiveImage/ProgressiveImage'

const Dashboard: React.FC = () => {
  const navigate = useNavigate()
  const { pageType } = useParams()
  const { pathname } = useLocation()
  const { setUserProfile } = useAuth()
  const { signout } = useAuthContext()
  const [contentUrl] = useState('')
  const isAccountDetailsPage = pathname === '/dashboard/account-details'
  const isAccountDetailsActive = isAccountDetailsPage && contentUrl === ''

  useEffect(() => {
    if (
      (pageType === null || pageType === undefined) &&
      !pathname.includes('account-details') &&
      !pathname.includes('add-students')
    ) {
      navigate('/dashboard/all-assigned-students')
    }
  }, [pageType, pathname, navigate])

  const handleSignOut = (): void => {
    signout()
      .then(() => {
        setUserProfile(null)
        navigate('/')
      })
      .catch((error) => logger.error(error))
  }

  return (
    <div className='font-primary flex bg-black min-h-screen p-8'>
      <div className='flex flex-col relative min-w-[325px] shadow-[0px_0px_20px_-4px_rgba(52,232,158,1)] shadow-[0px_0px_20px_-4px_rgba(52,232,158,1)] userdashboard-corner bg-dopage-lightGreen p-[5px]'>
        <div className='inside bg-[#0F3443] h-full w-full flex flex-col relative'>
          <header className='flex justify-center mt-[38px]'>
            <img
              src={logo}
              className='w-[138px] cursor-pointer'
              alt='logo'
            />
          </header>
          <ul className='px-[24px] mt-[50px] flex-1 flex flex-col'>
            {sidebarItems.map((sidebarItem, key) => (
              <button
                key={`side-bar-menu-${key}`}
                className={`flex cursor-pointer items-center text-[18px] rounded text-dopage-lightGreen font-bold py-[14px] px-[17px] hover:bg-[rgba(52,232,158,0.2)] ${(pageType === sidebarItem.slot) ? 'bg-[rgba(52,232,158,0.2)]' : ''}`}
                onClick={() => navigate(sidebarItem.slot)}
              >
                <img src={sidebarItem.icon} className='w-[27px]' alt={`icon-${key}`} />
                <span className='ml-4'>{sidebarItem.title}</span>
              </button>
            ))}
          </ul>
          <div className='px-[24px]'>
            <button
              className={`px-[17px] flex cursor-pointer items-center text-[18px] rounded text-dopage-lightGreen font-bold py-[14px] hover:bg-[rgba(52,232,158,0.2)] ${pathname === '/dashboard/add-students' ? 'bg-[rgba(52,232,158,0.2)]' : ''}`}
              onClick={() => navigate('add-students')}
            >
              <img src={excelIcon} className='w-[27px]' alt='Excel Student Import Icon' />
              <span className='ml-4'>ADD STUDENTS</span>
            </button>
          </div>
          <div className='px-[24px] pb-[50px] flex flex-col gap-[8px]'>
            <button
              className={`px-[17px] flex cursor-pointer items-center text-[18px] rounded text-dopage-lightGreen font-bold py-[14px] hover:bg-[rgba(52,232,158,0.2)] ${pathname === '/dashboard/account-details' ? 'bg-[rgba(52,232,158,0.2)]' : ''}`}
              onClick={() => navigate('account-details')}
              aria-label='Account Details'
            >
              <img src={menuIcon} className='w-[27px]' alt='Account Details Icon' />
              <span className='ml-4'>Account details</span>
            </button>
            <button
              data-testid='highlight-button-logout'
              className='px-[17px] flex cursor-pointer items-center text-[18px] rounded text-dopage-lightGreen font-bold py-[14px] hover:bg-[rgba(52,232,158,0.2)]'
              onClick={handleSignOut}
              aria-label='Log Out'
            >
              <ProgressiveImage src={logoutIcon} alt='' className='w-[27px]' />
              <Text
                type='span'
                text='LOG OUT'
                size='SM'
                bold
                className='ml-4 text-dopage-lightGreen'
              />
            </button>
          </div>
        </div>
      </div>
      <div className='flex flex-col w-full'>
        <div className='ml-5 flex flex-col relative flex-1 shadow-[0px_0px_20px_-4px_rgba(52,232,158,1)] bg-dopage-lightGreen p-[5px] userdashboard-corner'>
          <div className='inside h-full w-full bg-[#0F3443] flex flex-col'>
            <div className='flex-1'>
              <Outlet />
            </div>
            <AccountDetailsFooter
              isVisible={isAccountDetailsActive}
            />
          </div>
        </div>
      </div>

    </div>
  )
}

export default Dashboard
